import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { loadUserData, updateMyProfile, clearUserData } from 'Actions/user';
import { pageTitleDecorator, authenticatedPageDecorator } from 'Decorators';
import IconCard from 'Common/Cards/IconCard.jsx';

import Header from 'Components/Header';
import UserForm from './UserForm';
import Grid from '@material-ui/core/Grid/Grid';
import { ROLE_EDITORIAL_BOARD, ROLE_REVIEWER } from 'Constants';
import Tabs from 'Components/Tabs/Tabs';
import UserSubmissionsList from 'Layouts/UserEdit/containers/UserSubmissionsList';

@connect(
    store => ({
        loading: store.userData.loading,
        success: store.userData.success,
        error: store.userData.error,
        userData: store.userData.user,
        userId: store.auth.user.id,
    }),
    dispatch => ({
        loadUserData: id => dispatch(loadUserData(id)),
        updateMyProfile: data => dispatch(updateMyProfile(data)),
        clearUserData: () => dispatch(clearUserData()),
    })
)
@authenticatedPageDecorator()
@pageTitleDecorator('profile')
export default class Profile extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        loading: PropTypes.bool,
        success: PropTypes.bool,
        error: PropTypes.bool,
        userId: PropTypes.number,
        userData: PropTypes.object,
        loadUserData: PropTypes.func.isRequired,
        updateMyProfile: PropTypes.func.isRequired,
        clearUserData: PropTypes.func.isRequired,
        isOneOf: PropTypes.func.isRequired,
        match: PropTypes.object,
        history: PropTypes.object.isRequired,
    };

    /**
     * @type {Object}
     */
    static contextTypes = {
        intl: PropTypes.object.isRequired,
    };

    componentDidMount() {
        const { userId, loadUserData } = this.props;

        if (userId) {
            loadUserData(userId);
        }
    }

    componentWillUnmount() {
        const { clearUserData } = this.props;

        clearUserData();
    }

    tabs = [
        {
            name: 'general',
            text: 'profile.tab.general',
        },
        {
            name: 'reviews',
            text: 'profile.tab.reviews',
            hidden: !this.props.isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]),
        }
    ];

    renderUserForm = () => {
        const { updateMyProfile, userData } = this.props;

        return <UserForm onSubmit={updateMyProfile} initialValues={userData} />;
    };

    getActiveTab = () => {
        const { match, isOneOf } = this.props;
        return match.params && match.params.tab && isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) ? match.params.tab : 'general';
    };

    /**
     * Render submission tab
     *
     * @returns {*}
     */
    renderTab = () => {
        const { userId } = this.props;

        switch (this.getActiveTab()) {
            case 'reviews':
                return <UserSubmissionsList id={userId} isReviewer />;
            default:
                return <IconCard content={this.renderUserForm()}/>;
        }
    };

    handleClick = tab => {
        this.props.history.push(`/profile/${tab}`);
    };

    render() {
        const { isOneOf } = this.props;

        return (
            <div className="wrapJournalList">
                <Header title="title.profile" style={{paddingTop: '20px'}}/>

                <Grid container spacing={24}>
                    <Grid item xs={!isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) ? 12 : 10}>
                        <div>{this.renderTab()}</div>
                    </Grid>
                    {isOneOf([ROLE_EDITORIAL_BOARD, ROLE_REVIEWER]) && <Grid item xs={2}>
                        <Tabs
                            tabs={this.tabs}
                            active={this.getActiveTab()}
                            handleClick={this.handleClick}
                        />
                    </Grid>}
                </Grid>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Profile/Profile.jsx